import { LANDING_OFFER_FROM_META_KEY } from "../constants";
import { useEffect } from "react";
import { isOfMetaOrigin } from "../utils/marketing-url-params";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import useGlobalContext from "./useGlobalContext";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../store";
import useEvents from "./useEvents";

export default function useLogFORAPErrors(offerToken: string) {
  const isMetaUser = isOfMetaOrigin();
  const landingMetaOffer = flightsSessionStore.get(LANDING_OFFER_FROM_META_KEY);
  const { userAgent } = useGlobalContext();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const { grumble } = useEvents();
  const flightDetailsFetchStatus = store.flightDetails.fetchStatus;

  useEffect(() => {
    if (isMetaUser && landingMetaOffer == offerToken) {
      if (
        flightDetailsFetchStatus === "success" &&
        ["success", "failed"].includes(store.metaFlightDetails.fetchStatus)
      ) {
        //meta results can be empty or api could fail
        if (!store.metaFlightDetails.flight) {
          grumble(`FD success, FORAP failed for ${userAgent.isBot ? "bot" : "normal"} : ${isMetaUser}`, {
            url: `${location.href}&ext-origin=${isMetaUser}`
          });
        }
      } else if (
        flightDetailsFetchStatus === "failed" &&
        ["success", "failed"].includes(store.metaFlightDetails.fetchStatus)
      ) {
        if (store.metaFlightDetails.flight) {
          grumble(`FD failed, FORAP success for ${userAgent.isBot ? "bot" : "normal"} : ${isMetaUser}`, {
            url: `${location.href}&ext-origin=${isMetaUser}`
          });
        } else {
          grumble(`FD and FORAP failed for ${userAgent.isBot ? "bot" : "normal"} : ${isMetaUser}`, {
            url: `${location.href}&ext-origin=${isMetaUser}`
          });
        }
      }
    }
  }, [flightDetailsFetchStatus]); // eslint-disable-line react-hooks/exhaustive-deps
}
